import { useEffect, useState } from 'react';
import { useApolloClient, useQuery } from '@apollo/client';

import { LOCAL_SHOW_ONBOARDS, TOGGLE_SHOW_ONBOARD } from '../../shared';

export default function useShowOnboards() {
  const [promises, setPromises] = useState([]);
  const [didMutate, setDidMutate] = useState(false);

  const showOnboardsQuery = useQuery(LOCAL_SHOW_ONBOARDS);

  const client = useApolloClient();

  useEffect(() => {
    if (showOnboardsQuery?.loading) return;

    if (!promises.length && showOnboardsQuery?.data?.showOnboards) {
      const showOnboards = showOnboardsQuery?.data?.showOnboards;
      const promisesArr = showOnboards.map((onboard) =>
        client.mutate({
          mutation: TOGGLE_SHOW_ONBOARD,
          variables: {
            name: onboard?.name,
            show: false,
          },
        })
      );
      setPromises(promisesArr);
    }

    if (promises.length && !didMutate) {
      Promise.all(promises)
        .then(() => {
          setDidMutate(true);
        })
        .catch(() => {});
    }
  }, [showOnboardsQuery, client, promises, didMutate]);
}
